export const dailyAmplitudeStatsCalculator = (data, numDays) => {
    const dailyAmplitudes = [];
    const dataHigh = data.h.slice(0, -1);
    const dataLow = data.l.slice(0, -1);
    const dataData = data.t.slice(0, -1);
    for (let i = dataData.length; i >= Math.max(dataData.length - numDays, 0); i--) {
        const amplitude = dataHigh[i] - dataLow[i];
        dailyAmplitudes.unshift(amplitude);
    }
    dailyAmplitudes.pop();
    const sum = dailyAmplitudes.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const average = dailyAmplitudes.length > 0 ? sum / dailyAmplitudes.length : 0;
    const max = dailyAmplitudes.length > 0 ? Math.max(...dailyAmplitudes) : 0;
    const min = dailyAmplitudes.length > 0 ? Math.min(...dailyAmplitudes) : 0;
    //console.log('max:', max, 'min:', min, 'all:', dailyAmplitudes)
    const belowAverageAmplitudes = dailyAmplitudes.filter(amplitude => amplitude < average);
    const aboveAverageAmplitudes = dailyAmplitudes.filter(amplitude => amplitude > average);
    const belowAverage = belowAverageAmplitudes.length > 0
        ? belowAverageAmplitudes.reduce((accumulator, currentValue) => accumulator + currentValue, 0) / belowAverageAmplitudes.length
        : 0;
    const aboveAverage = aboveAverageAmplitudes.length > 0
        ? aboveAverageAmplitudes.reduce((accumulator, currentValue) => accumulator + currentValue, 0) / aboveAverageAmplitudes.length
        : 0;
    return {
        average,
        max,
        min,
        belowAverage,
        aboveAverage,
    };
};
